export default __webpack_public_path__ + "static/media/iPhone X_MockUp.f9ca6795.png";